/**
 * Created by jonas on 2021-02-09.
 */
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {
    SimpleReelModel,
    SimpleReelModelDelegate,
    SimpleReelModelState,
} from "../../core/reel/simplereel/SimpleReelModel";
import {Outsourced} from "../Outsourced";
import {LayersSet} from "./LayersSet";
import {OutsourcedSymbol} from "./symbols/OutsourcedSymbol";
import {OutsourcedGameAssets} from "../OutsourcedGameAssets";
import {gsap} from "gsap";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {LoopableList} from "../utils/LoopableList";
import {reelPosition} from "../server/OutsourcedModel";
import {SpineGSAPWrapper} from "../animation/SpineGSAPWrapper";
import {BasedMiniReel} from "./BasedMiniReel";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";

export class OutsourcedReelView extends PIXI.Container implements StageLayer {

    public conveyorBelts:PIXI.spine.Spine[];
    public reelModels:BasedMiniReel[];
    //public multipliers:PIXI.Text[];
    public multipliers:PIXI.BitmapText[];

    public ways:PIXI.BitmapText;

    //public symbolContainer:PIXI.Container;
    public symbols:OutsourcedSymbol[];

    private symbolWidth:number = 180;
    private symbolHeight:number = 148;
    public static stepDuration:number = 0.04;

    private symbolMask:PIXI.Graphics;

    landDust:PIXI.spine.Spine[];
    xBetGlass:PIXI.Sprite;

    isFreespins:boolean = false;

    private static FREE_SPINS_REEL:string[] = ["XW", "L1","L2","L3","L4","M1","W","M2","M3","M4"];
    private static BASE_GAME_REEL:string[] = ["XW","L1","L2","L3","L4","M1","M2","M3","M4", "SC"];

    constructor() {
        super();
        this.name = "OutsourcedReelView";
        this.reelModels = [];
        this.multipliers = [];
        this.conveyorBelts = [];
        this.symbols = [];
        this.sortableChildren = true;

        const multiplierStyle = new PIXI.TextStyle({
            "dropShadow": true,
            "dropShadowAngle": 8.7,
            "dropShadowColor": "#000033",
            "dropShadowDistance": 4,
            "fill": "#ffffff",
            "fontFamily": "Helvetica",
            "fontSize": 36,
            "fontWeight": "bold",
            "lineJoin": "round",
            "miterLimit": 0,
            "stroke": "#000033",
            "strokeThickness": 4
        });

        for (let i:number = 0; i < 4; i++){
            for (let j:number = 0; j < 4; j++){
                const conveyor = new PIXI.spine.Spine(Outsourced.assetLoader.getSpineAsset(OutsourcedGameAssets.CONVEYOR_BELT));
                conveyor.state.setAnimation(0, "Conveyor_Spin_Stop", false);
                conveyor.position.set((i + 0.5) * this.symbolWidth, 90 + this.symbolHeight * (j + 0.5));
                conveyor.zIndex = 0;
                this.conveyorBelts.push(conveyor);
                this.addChild(conveyor);

                const reel = new BasedMiniReel(i, 1);
                reel.reelSet = OutsourcedReelView.BASE_GAME_REEL;
                this.reelModels.push(reel);
                reel.position.set((i + 0.5) * this.symbolWidth, 90 + this.symbolHeight * (j + 0.5));
                this.addChild(reel);

            }
        }

        //this.symbolContainer = new PIXI.Container;
        //this.addChild(this.symbolContainer);

        for (let i:number = 0; i < 4; i++){
            for (let j:number = 0; j < 4; j++){
                //const multiplier = new PIXI.Text("420x", multiplierStyle);
                const multiplier = new PIXI.BitmapText("420x", {
                    fontSize: 50,
                    fontName: OutsourcedGameAssets.BITMAP_FONT_FS_MULTI
                });
                (<PIXI.Point>multiplier.anchor).set(1, 1);
                multiplier.position.set((i + 1) * this.symbolWidth - 20, 106 + this.symbolHeight * (j + 1));
                this.multipliers.push(multiplier);
                multiplier.zIndex = 1 + 2 * (i * 4 + j);
                this.addChild(multiplier);

            }
        }

        this.ways = new PIXI.BitmapText("42069", {
            fontName: OutsourcedGameAssets.WAYS_FONT,
            fontSize: 50,
        });
        (<PIXI.Point>this.ways.anchor).set(0, 0.5);
        this.ways.position.set(410, 40);
        this.addChild(this.ways)

        this.resetMultipliers();

        this.landDust = [];
        for (let i = 0; i < 4; i++) {
            this.landDust[i] = new PIXI.spine.Spine(Outsourced.assetLoader.getSpineAsset(OutsourcedGameAssets.LANDING_DUST));
            this.landDust[i].alpha = 0;
            this.addChild(this.landDust[i]);
        }

        this.xBetGlass = new PIXI.Sprite(Outsourced.assetLoader.getTextures("X_Bet_Glass")[0]);
        this.xBetGlass.anchor.set(0.5, 0.5);
        this.xBetGlass.position.set(268, 160);
        this.xBetGlass.visible = false;
        this.xBetGlass.zIndex = 420;
        this.addChild(this.xBetGlass);
    }

    public updateWays(newValue:number, instant:boolean = true):void {
        if (instant)
            this.ways.text = `${newValue}`;
        else
            gsap.timeline()
                .add(gsap.to(this.ways, {text: `${newValue}`, duration: 0.2, ease:"none", onUpdate:() => {
                            this.ways.text = `${Math.floor(parseFloat(this.ways.text))}`;
                        }}))
                .add(Outsourced.soundPlayer.playSoundBased("waysCounter"), '<')
    }

    public resetWays():void {
        this.updateWays(256);
    }

    public resetMultipliers(target:number = 1):void {
        for (let i:number = 0; i < 4; i++){
            for (let j:number = 0; j < 4; j++){
                this.setMultiplierTo(target, i, j);
                this.undarkenMultiplier(i, j);
            }
        }
    }

    public startConveyorBelt(reel:number, row:number, respin:boolean = false): gsap.core.Timeline {
        const isFreespins = this.isFreespins
        return gsap.timeline().add(() => {
            //this.conveyorBelts[reel * 4 + row].state.setAnimation(0, `Conveyor_${respin ? "Res" : "S"}pin_Loop`, true);
            if (respin)
                this.conveyorBelts[reel * 4 + row].state.setAnimation(0, `Conveyor_Respin_Loop`, true);
            else
                this.conveyorBelts[reel * 4 + row].state.setAnimation(0, `Conveyor_Spin_Loop${isFreespins ? "_FS" : ""}`, true);
        })
    }

    public stopConveyorBelt(reel:number, row:number, respin:boolean = false): gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                if (respin)
                    this.conveyorBelts[reel * 4 + row].state.setAnimation(0, "Conveyor_Respin_Out", false);
                else
                    this.conveyorBelts[reel * 4 + row].state.setEmptyAnimation(0, 0);
            })
    }

    public setMultiplierTo(newValue:number, reel:number, row:number):void {
        this.multipliers[reel * 4 + row].text = `X${newValue}`;
        this.multipliers[reel * 4 + row].visible = newValue > 1;
    }

    public darkenMultiplier(reel:number, row:number) {
        this.multipliers[reel * 4 + row].alpha = 0.4;
    }

    public undarkenMultiplier(reel:number, row:number) {
        this.multipliers[reel * 4 + row].alpha = 1;
    }

    public setToFreespins() {
        for (let reel = 0; reel < 4; reel++) {
            for (let row = 0; row < 4; row++) {
                this.conveyorBelts[reel * 4 + row].state.setAnimation(0, "Conveyor_Spin_Loop_FS", false);
                this.conveyorBelts[reel * 4 + row].state.getCurrent(0).time = 1;
            }
        }
        this.isFreespins = true;
    }

    public setToNormal() {
        for (let reel = 0; reel < 4; reel++)
            for (let row = 0; row < 4; row++)
                this.conveyorBelts[reel * 4 + row].state.setEmptyAnimation(0, 0);
        this.isFreespins = false;
    }

    public enable() {
        this.visible = true;
    }

    public disable() {
        this.visible = false;
    }

    public setFreeSpinsReelSet():void {
        this.reelModels.forEach((reel) => {
            reel.reelSet = OutsourcedReelView.FREE_SPINS_REEL;
        })
    }

    insertSymbols() {
        //this.symbolContainer.removeChildren(0, this.symbolContainer.children.length);
        this.reelModels.forEach((reel, index) => {
            this.removeChild(this.symbols[index])
            reel.insertSymbols([this.symbols[index]])
        });
        this.symbols = [];
    }

    extractSymbols() {
        this.symbols = this.reelModels.map((reel) => reel.extractSymbols()[0]);
        this.symbols.forEach((sym, index) => {
            sym.zIndex = index * 2;
            this.addChild(sym)
            sym.position.copyFrom(this.reelModels[index]);
        });
    }

    getAllSymbols():OutsourcedSymbol[] {
        return this.symbols;
    }

    getSymbolAt(reel:number, row:number):OutsourcedSymbol {
        // if its spinning or not
        return this.symbols.length == 0 ? this.reelModels[reel * 4 + row].getSymbols()[0] : this.symbols[reel * 4 + row];
    }

    getAllStoppedSymbols(): OutsourcedSymbol[] {
        return this.reelModels.filter((reelModel) => !reelModel.isSpinning).map((reelModel) => reelModel.getSymbols()[0])
    }

    setSymbolAt(reel:number, row:number, symbol:OutsourcedSymbol):void {
        const oldSymbol = this.getSymbolAt(reel, row);
        symbol.position.copyFrom(oldSymbol.position);
        this.symbols[reel * 4 + row] = symbol;
        //this.symbolContainer.addChildAt(symbol, reel * 4 + row);
        symbol.zIndex = 2 * (reel * 4 + row);
        this.addChild(symbol);
        this.removeChild(oldSymbol);
    }

    moveUpZ(reel:number, row:number):void {
        this.multipliers[reel * 4 + row].zIndex += 10;
        this.symbols[reel * 4 + row].zIndex += 10;
    }

    moveDownZ(reel:number, row:number):void {
        this.multipliers[reel * 4 + row].zIndex -= 10;
        this.symbols[reel * 4 + row].zIndex -= 10;
    }

    public playLandDust(reel:number, row:number): gsap.core.Timeline {
        return gsap.timeline()
                .add(() => {
                    this.landDust[reel].alpha = 1
                    this.landDust[reel].position.set((reel + 0.5) * this.symbolWidth, 90 + this.symbolHeight * (row + 0.5));
                })
                .add(SpineGSAPWrapper.createTimeline(this.landDust[reel], 0, "Landing"))
                .add(() => {this.landDust[reel].alpha = 0})
    }

    enableXBet() {
        this.xBetGlass.visible = true;
    }

    disableXBet() {
        this.xBetGlass.visible = false;
    }
}